import { render, staticRenderFns } from "./ShortcutTool.vue?vue&type=template&id=4fa30193&scoped=true&"
import script from "./ShortcutTool.vue?vue&type=script&lang=js&"
export * from "./ShortcutTool.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutTool.vue?vue&type=style&index=0&id=4fa30193&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa30193",
  null
  
)

export default component.exports